import { useState, useEffect } from 'react'
import { gql } from '@apollo/client'
import { Table, Alert } from 'reactstrap'
import Spinner from '../../Spinner/Spinner.js'
import '../Custom.css'
import { getData } from '../CustomUtils'
import { DUPLICATE_SSN_REPORT_QUERY } from '../../../graphql.js'
import ColumnHeadings from '../ColumnHeadings.js'
import ResultsGrid from '../ResultsGrid.js'
import ParameterValues from '../ParameterValues.js'
import { getLoginInfo, getTenant } from '../../../utils.js'
import LargeRowHandler from '../LargeRowHandler.js'
import ReportHeading from '../ReportHeading.js'

const DUPLICATE_SSN_REPORT = gql(DUPLICATE_SSN_REPORT_QUERY)

export default function DuplicateSSNReport({ location }) {
  console.log('DuplicateSSNReport rendered:', location)

  const [results, setResults] = useState()
  const [graphQLErrors, setGraphQLErrors] = useState([])

  useEffect(() => {
    getData(location, DUPLICATE_SSN_REPORT, 'duplicateSSNReport', setResults, setGraphQLErrors)
  }, [location])

  if (graphQLErrors.length > 0) {
    return <Alert color="danger">{graphQLErrors[0].message}</Alert>
  } else if (!results) {
    return <Spinner />
  } else {
    const inputs= getLoginInfo()
    const resultRows = ResultsGrid(results, 0, 6, location)
    const csvUrl = `${process.env.REACT_APP_SERVER}/csv/${getTenant()}/custom/Asbestos/duplicateSSNReport/duplicate_ssn_report.csv?inputs=${inputs.id}`
    return (
      <div className="custom-scroll"> 
        <div style={{ textAlign: 'center', margin: '10px 0px' }}>
          <LargeRowHandler csvUrl={csvUrl} resultsLength={results.reportData.length} />
        </div>
        <Table bordered style={{backgroundColor: 'white'}} >
          <ReportHeading title={'Duplicate SSN Report'} parameterValues={ParameterValues(results)} />
          <tbody>
            <ColumnHeadings results={results} />
            {resultRows}
          </tbody>
        </Table>
      </div>
    )
  }
}